<template>
  <div>
    <h1 style="padding-bottom:15px;">My Settings</h1>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <v-alert
      :value="$route.query.reset"
      type="warning"
    >
      Please change your password to continue.
    </v-alert>
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs3
        style="text-align:center;margin-top:25px;"
      >
        <v-icon
          size="155"
          color="grey"
        >
          person_pin_circle
        </v-icon>
        <div
          style="text-align:left;margin-top:25px;"
          class="details"
        >
          <span style="font-size:24px;">{{ user.first_name }} {{ user.last_name }}</span>
          <span><b>Username: </b>{{user.username}}</span>
          <span><b>E-mail: </b>{{user.email}}</span>
          <span><b>Organization: </b>#</span>
          <span><b>Date Created: </b>{{user.date_joined}}</span>
        </div>
      </v-flex>
      <v-flex
        xs8
        offset-xs1
      >
        <v-alert
          :value="failed"
          type="error"
        >
          Failed to save. Check your password, then try again.
        </v-alert>
        <v-alert
          :value="done"
          type="success"
        >
          Information has been updated!
        </v-alert>
        <v-form ref="editForm">
          <v-card
            style="margin:15px;"
          >
            <v-toolbar
              flat
              dense
            >
              Account Information
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="edituser.email"
                :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid']"
                label="E-mail"
              />
              <v-text-field
                v-model="edituser.phone"
                :rules="edituser.phone ? [v => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) || 'Phone Number must match ###-###-####, ##########, ### ### #### or any equivalent format'] : []"
                label="Mobile Phone"
              />
            </v-card-text>
          </v-card>
          <v-card
            style="margin:15px;"
          >
            <v-toolbar
              flat
              dense
            >
              Notification Preferences
              <span style="font-weight:700;">
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span v-if="tagStatus === 'saving'">
                  Saving Preferences...
                </span>
                <span v-if="tagStatus === 'saved'">
                  Preferences Saved!
                </span>
                <span v-if="tagStatus === 'error'">
                  !! Something went wrong !!
                </span>
              </span>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <span>How would you like to receive notifications?</span>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-switch
                    v-model="edituser.notify_by_email"
                    style="display:inline;text-align:center;"
                    label="Via E-mail"
                    :hint="user.email"
                    persistent-hint
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm4>
                <!--
                  <v-switch
                    v-model="edituser.notify_by_phone"
                    style="display:inline;"
                    label="Via SMS"
                    :hint="user.phone"
                    persistent-hint
                  ></v-switch>
                -->
                </v-flex>
              </v-layout>
              <br />
              <hr />
              <br />
              <p style="font-weight:500;font-size:18px;">Form Subscriptions</p>
              <div
                v-for="tag in formTagSubs"
                :key="tag.slug"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm3>
                    <v-chip
                      label
                      small
                    >
                      {{tag.tag}}
                    </v-chip>
                    <span>
                      <v-icon
                        small
                        right
                        @click="deleteFormSub(tag)"
                      >
                        delete_forever
                      </v-icon>
                    </span>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="tag.on_client_start"
                      style="display:inline;"
                      label="On Client Start"
                      @change="updateFormTag(tag)"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="tag.on_client_submit"
                      style="display:inline;"
                      label="On Client Submission"
                      @change="updateFormTag(tag)"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="tag.on_client_sign"
                      style="display:inline;"
                      label="On Client Signing"
                      @change="updateFormTag(tag)"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </div>
              <v-btn
                small
                v-if="!addFormTag"
                @click="addFormTag = true"
              >
                <v-icon small left>add</v-icon>
                Add Form Subscription
              </v-btn>
              <v-expand-transition>
                <div v-if="addFormTag">
                  <v-autocomplete
                    v-model="filterFormTags"
                    :items="tagFormResults"
                    :search-input.sync="tagFormSearch"
                    label="Search for a Tag"
                    dense
                    return-object
                    item-text="tag"
                    auto-select-first
                    hide-details
                  />
                </div>
              </v-expand-transition>
              <br />
              <br />
              <p style="font-weight:500;font-size:18px;">Contact Subscriptions</p>
              <div
                v-for="tag in contactTagSubs"
                :key="tag.slug"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4>
                    <v-chip
                      label
                      small
                    >
                      {{tag.tag}}
                    </v-chip>
                    <span>
                      <v-icon
                        small
                        right
                        @click="deleteContactSub(tag)"
                      >
                        delete_forever
                      </v-icon>
                    </span>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-switch
                      v-model="tag.on_client_file_upload"
                      style="display:inline;"
                      label="On Client File Upload"
                      @change="updateContactTag(tag)"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-switch
                      v-model="tag.on_client_message"
                      style="display:inline;"
                      label="On Client Communication"
                      @change="updateContactTag(tag)"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </div>
              <v-btn
                small
                v-if="!addContactTag"
                @click="addContactTag = true"
              >
                <v-icon small left>add</v-icon>
                Add Contact Subscription
              </v-btn>
              <v-expand-transition>
                <div v-if="addContactTag">
                  <v-autocomplete
                    v-model="filterContactTags"
                    :items="tagContactResults"
                    :search-input.sync="tagContactSearch"
                    label="Search for a Tag"
                    dense
                    return-object
                    item-text="tag"
                    auto-select-first
                    hide-details
                  />
                </div>
              </v-expand-transition>
            </v-card-text>
          </v-card>
          <v-card
            style="margin:15px;"
          >
            <v-toolbar
              flat
              dense
            >
              Change Password
            </v-toolbar>
            <v-card-text>
              <v-expand-transition>
                <v-alert
                  v-if="passwordFeedback && passwordFeedback.suggestions.length > 0"
                  :value="true"
                  type="info"
                  outline
                >
                  <b>Here are some suggestions to improve your password:</b><br />
                  <div
                    v-for="suggestion in passwordFeedback.suggestions"
                    :key="suggestion"
                  >
                    {{suggestion}}
                  </div>
                </v-alert>
              </v-expand-transition>
              <v-text-field
                v-model="user.newPass1"
                type="password"
                :rules="[securityRules.min, securityRules.strength]"
                label="New Password"
                autocomplete="new-password"
                loading
              >        
                <template slot="progress">
                  <v-progress-linear
                    :value="passwordScore * 25"
                    :color="passwordScore > 2 ? 'success' : 'error'"
                    height="7"
                  />
                </template>
              </v-text-field>
              <v-text-field
                v-model="user.newPass2"
                :rules="user.newPass1 ? [user.newPass2 == user.newPass1 || 'Passwords do not match'] : []"
                type="password"
                label="New Password (Again)"
              />
            </v-card-text>
          </v-card>
          <v-card
            style="margin:15px;"
          >
            <v-card-text>
              Please enter your current password to make any changes to your profile.
              <v-text-field
                v-model="edituser.password"
                :rules="[v => !!v || 'Your Current Password is required to update your profile']"
                type="password"
                label="Current Password"
                name="password"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                :disabled="saving"
                color="primary"
                @click="save"
              >Save Changes</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import zxcvbn from 'zxcvbn'

export default {
  name: 'CurrentUser',
  data () {
    return {
      user: {},
      edituser: {},
      loading: false,
      failed: false,
      done: false,
      formTagSubs: [],
      contactTagSubs: [],
      tagStatus: '',
      addFormTag: false,
      addContactTag: false,
      filterContactTags: null,
      filterFormTags: null,
      tagFormSearch: null,
      tagContactSearch: null,
      tagSearchStorage: [],
      saving: false,
      securityRules: {
        min: v=> v ? v.length >= 8 || 'Your password must contain more than 8 characters' : true,
        strength: v => v ? zxcvbn(v).score >= 3 || this.passwordFeedback.warning || "That password doesn't meet our security requirements." : true
      }
    }
  },
  computed: {
    passwordScore () {
      return this.user.newPass1 ? zxcvbn(this.user.newPass1).score : 0
    },
    passwordFeedback () {
      return this.user.newPass1 ? zxcvbn(this.user.newPass1).feedback : null
    },
    tagFormResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.formTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    },
    tagContactResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.contactTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    }
  },
  created () {
    this.documentTitle('My Settings')
    this.fetch()
  },
  watch: {
    tagContactSearch () {
      if (this.tagContactSearch) {
        this.fetchContactTags()
      }
    },
    tagFormSearch () {
      if (this.tagFormSearch) {
        this.fetchFormTags()
      }
    },
    filterFormTags () {
      this.addFormTag = false
      if (this.filterFormTags !== null) {
        this.formTagSubs.push(this.filterFormTags)
        this.tagFormSearch = null
        this.tagSearchStorage = []
        this.filterFormTags = null
      }
    },
    filterContactTags () {
      this.addContactTag = false
      if (this.filterContactTags !== null) {
        this.contactTagSubs.push(this.filterContactTags)
        this.tagContactSearch = null
        this.tagSearchStorage = []
        this.filterContactTags = null
      }
    }
  },
  methods: {
    fetch () {
      this.loading = true
      api.auth.currentuser.get()
        .then(user => {
          this.user = user
          this.loading = false
          this.edituser = JSON.parse(JSON.stringify(this.user))
          this.edituser.password = ''
        })
      api.userform.userformTags.getSubs()
        .then(formTags => {
          this.formTagSubs = formTags
        })
      api.userform.contactTags.getSubs()
        .then(contactTags => {
          this.contactTagSubs = contactTags
        })
    },
    save () {
      if (this.$refs.editForm.validate()) {
        this.saving = true
        this.failed = false
        this.loading = true
        this.edituser.newPassword = this.user.newPass1 || null
        api.auth.currentuser.save(this.edituser)
          .then(user => {
            this.saving = false
            this.edituser.password = ''
            this.user = user
            this.loading = false
            this.done = true
            this.$store.state.auth.reset = false
            if (this.$route.query.from) {
              this.$router.replace(this.$route.query.from)
            }
          })
          .catch(() => {
            this.failed = true
            this.loading = false
          })
      }
    },
    updateFormTag (tag) {
      this.tagStatus = 'saving'
      api.userform.userformTags.updateSub(tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteFormSub (tag) {
      this.tagStatus = 'saving'
      api.userform.userformTags.deleteSub(tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.formTagSubs = this.formTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    updateContactTag (tag) {
      this.tagStatus = 'saving'
      api.userform.contactTags.updateSub(tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteContactSub (tag) {
      this.tagStatus = 'saving'
      api.userform.contactTags.deleteSub(tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.contactTagSubs = this.contactTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    fetchFormTags () {
      api.userform.userformTags.get(this.tagFormSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    },
    fetchContactTags () {
      api.userform.contactTags.get(this.tagContactSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    }
  }
}
</script>

<style scoped>
  .details span {
    display:block;
    padding:3px;
  }
</style>
